import { useState } from "react";
import api, { apiErrorMessage } from "@/api/client";
import { useAdminAuth } from "@/context/AdminAuthContext";
import { KeyRound, CheckCircle2 } from "lucide-react";

export default function AdminSettings() {
  const { admin, refresh } = useAdminAuth();
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [ok, setOk] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(""); setOk(false);
    if (newPassword !== confirmPassword) { setError("Las contraseñas nuevas no coinciden."); return; }
    try {
      await api.post("/auth/admin/change-password", { current_password: currentPassword, new_password: newPassword });
      setOk(true);
      setCurrentPassword(""); setNewPassword(""); setConfirmPassword("");
      refresh();
    } catch (err) {
      setError(apiErrorMessage(err));
    }
  };

  return (
    <div className="space-y-6 max-w-lg">
      <div>
        <h1 className="text-2xl font-black text-slate-800">Ajustes de la cuenta</h1>
        <p className="text-sm text-slate-500">{admin?.email}</p>
      </div>

      {admin?.must_change_password && (
        <div className="bg-amber-50 border border-amber-200 rounded-xl p-4 text-xs font-semibold text-amber-800">
          Por seguridad, cambia la contraseña temporal antes de continuar.
        </div>
      )}

      <form onSubmit={handleSubmit} className="bg-white rounded-2xl border border-slate-200 p-6 shadow-sm space-y-4" data-testid="admin-change-password-form">
        <div className="flex items-center gap-2 mb-2"><KeyRound className="w-4 h-4 text-brand-slate" /><h3 className="text-sm font-black text-slate-800">Cambiar contraseña</h3></div>
        <div>
          <label className="block text-xs font-bold text-slate-700 uppercase mb-1.5">Contraseña actual</label>
          <input data-testid="admin-current-password" type="password" placeholder="Tu contraseña actual" value={currentPassword} onChange={(e) => setCurrentPassword(e.target.value)} className="w-full px-4 py-2.5 rounded-xl border border-slate-300 bg-slate-50 text-sm" />
        </div>
        <div>
          <label className="block text-xs font-bold text-slate-700 uppercase mb-1.5">Nueva contraseña</label>
          <input data-testid="admin-new-password" type="password" placeholder="Mínimo 8 caracteres" value={newPassword} onChange={(e) => setNewPassword(e.target.value)} className="w-full px-4 py-2.5 rounded-xl border border-slate-300 bg-slate-50 text-sm" />
        </div>
        <div>
          <label className="block text-xs font-bold text-slate-700 uppercase mb-1.5">Confirmar nueva contraseña</label>
          <input data-testid="admin-confirm-password" type="password" placeholder="Repite la nueva contraseña" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} className="w-full px-4 py-2.5 rounded-xl border border-slate-300 bg-slate-50 text-sm" />
        </div>
        {error && <div className="text-xs font-semibold text-rose-600 bg-rose-50 border border-rose-200 rounded-xl px-4 py-3">{error}</div>}
        {ok && <div className="flex items-center gap-2 text-xs font-semibold text-emerald-600"><CheckCircle2 className="w-4 h-4" /> Contraseña actualizada correctamente.</div>}
        <button data-testid="admin-change-password-submit" type="submit" className="px-6 py-2.5 bg-brand-slate hover:bg-slate-900 text-white text-xs font-bold rounded-xl">Guardar cambios</button>
      </form>
    </div>
  );
}
